import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { PRACTICE_AREAS } from "../data/content";

export default function PracticeAreas() {
  return (
    <section id="practice" className="relative z-10 py-28 md:py-40 bg-[#0B132B]/40" data-testid="practice">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
            <div>
              <p className="text-sm font-500 tracking-[0.3em] uppercase text-[#D95A41] mb-6">Practice Areas</p>
              <h2 className="text-4xl md:text-6xl font-900 tracking-tightest max-w-2xl leading-[1] text-[#F2EFE9]">
                Integrated capability, end to end.
              </h2>
            </div>
            <p className="max-w-sm text-[#94A3B8] leading-relaxed">
              From daily contracting to the courtroom — whether we act as your embedded Fractional GC or as private counsel on a single matter, aligned to your commercial reality.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-3xl overflow-hidden">
          {PRACTICE_AREAS.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
              className="group grid-cell-hover bg-[#050A14] hover:bg-[#D95A41] p-8 min-h-[300px] flex flex-col cursor-default"
              data-testid={`practice-card-${p.n}`}
            >
              <span className="text-sm font-700 text-[#94A3B8] group-hover:text-[#F2EFE9]/70 transition-colors duration-300 mb-16 block">
                {p.n}
              </span>
              <h3 className="text-xl font-700 text-[#F2EFE9] mb-3 tracking-tight min-h-[3.5rem] leading-tight">{p.title}</h3>
              <p className="text-sm text-[#94A3B8] group-hover:text-[#F2EFE9] transition-colors duration-300 leading-relaxed mb-5">
                {p.desc}
              </p>
              <Link
                to={`/home/practice/${p.slug}`}
                data-testid={`practice-readmore-${p.slug}`}
                className="mt-auto inline-flex items-center gap-1.5 text-xs font-700 tracking-[0.15em] uppercase text-[#D95A41] group-hover:text-[#F2EFE9] transition-colors self-start relative"
              >
                <span className="relative">
                  Read more
                  <span className="absolute left-0 -bottom-0.5 w-full h-px bg-current opacity-40 group-hover:opacity-100 transition-opacity" />
                </span>
                <ArrowUpRight size={13} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
